import React from 'react';
import Header from '../components/Header';
import MainContent from '../components/MainContent';
import Footer from '../components/Footer';
import { Container } from '../styles/ContainerStyles';


const HomePage: React.FC = () => {
    return (
        <Container>
            <Header />
            <MainContent />
            <Footer />
        </Container>
    );
};

export default HomePage;
